/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {AlertConfigCommandContract} from '../../../../api/ms-settings/alerts-config/contracts/alert-config-command.contract';
import {AlertConfigModel} from '../models/alert-config.model';
import {toBase64Utf16LittleEndian} from '../../../../shared/utils/encode/encodeToBase64Utf16LE';

export class AlertsCreateNewMapper<T, N> {

    static fromFormDataValueToAlertConfigCommandContract(data: AlertConfigModel, scheduleActive: boolean): AlertConfigCommandContract {
        return {
            name: data?.name?.value,
            description: toBase64Utf16LittleEndian(data?.description?.value),
            active: data?.active,
            ...this.fromFormDataValueToScheduleDates(data, scheduleActive)
        };
    }

    static fromFormDataValueToScheduleDates(data: AlertConfigModel, scheduleActive: boolean): Partial<AlertConfigCommandContract> {
        if (data?.scheduleStartsOn?.value != null && scheduleActive) {
            return {
                scheduleStartsOn: data.scheduleStartsOn.value,
                scheduleEndsOn: data.scheduleEndsOn?.value != null ? data.scheduleEndsOn.value : undefined
            };
        }
    }
}
